let utils = require( './utils' );

let delete_proposal = (function( $ ) {

	let $anchors;

	let init = function() {
		$anchors = $( 'a.ajax-delete-proposal' );

		if ( $anchors.length > 0 ) {
			$anchors.on( 'click', _delete_proposal );
		}
	};

	let _delete_proposal = function( e ) {
		e.preventDefault();

		utils.show_spinner();

		let data = {
			action: 'crate_delete_proposal',
			nonce: ScriptData.crate_delete_proposal_nonce,
			proposal: $( this ).data( 'proposal' ),
			redirect : $( this ).data( 'redirect' ) ? $( this ).data( 'redirect' ) : window.location.href
		};

		$.post( ScriptData.ajaxurl, data, _delete_proposal_response );
	};

	let _delete_proposal_response = function( response ) {
		if ( ! response.success ) {
			utils.hide_spinner();
			return;
		}

		window.location.href = response.redirect;
	};

	$( document ).ready( init );

	return {
		init: init
	};

})( jQuery );

module.exports = delete_proposal;